import { render, staticRenderFns } from "./ModalAddExhibitionCategory.vue?vue&type=template&id=45564300&scoped=true"
import script from "./ModalAddExhibitionCategory.vue?vue&type=script&lang=js"
export * from "./ModalAddExhibitionCategory.vue?vue&type=script&lang=js"
import style0 from "./ModalAddExhibitionCategory.vue?vue&type=style&index=0&id=45564300&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45564300",
  null
  
)

export default component.exports